<template>
  <div class="sureOrder">
    <HeadBack title="确认订单" />
    <addressList :choose-add-id="chooseAddId" @changAddId="changeAddId" />
    <div class="orderDetail">
      <!-- 订单详情 -->
      <div class="orderTitle">
        <div class="leftTitle">
          确认商品信息
        </div>
        <div class="accountWrap">
          可用 <i v-if="applyObj.payType==5" style="color:#fff">￥</i><span class="price">{{ myAccount.balance?myAccount.balance:0 }}</span> <i v-if="applyObj.payType!=5">{{ applyObj.symbolNameCh }}</i>
        </div>
      </div>
      <div class="goodInfo">
        <div class="fristRow">
          <p class="twoCol">商品描述</p>
          <p class="threeCol">价格</p>
          <p class="fourCol">数量</p>
          <p class="fiveCol">合计</p>
        </div>
        <div class="twoRow">
          <div class="twoCol">
            <img :src="goodImg.img" alt="" class="imgWrap">
            <div>
              <p class="name">{{ applyObj.commodityName }}</p>
              <!-- <p class="place">已售:{{ applyObj.salesNumber }}{{ applyObj.unitQuantifier }}</p> -->
              <p class="prices">原价:￥{{ applyObj.marketPrice }}</p>
            </div>
          </div>
          <div class="threeCol">
            <p v-if="applyObj.payType==6">
              <span class="price">{{ applyObj.price }}<i class="newSty">{{ applyObj.symbolNameCh }}</i></span>
            </p>
            <p v-else>
              <span class="price"><i>￥</i>{{ applyObj.price }}</span>
            </p>
          </div>
          <p class="fourCol">
            <el-input-number v-model="buyNum" :min="1" label="" :precision="0" onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"></el-input-number>
          </p>
          <div class="fiveCol">
            <p v-if="applyObj.payType==6">
              <span class="price">{{ totalPrice }}<i>{{ applyObj.symbolNameCh }}</i></span>
            </p>
            <p v-else>
              <span class="price"><i>￥</i>{{ totalPrice }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="orderAction noLeftw">
        <div v-if="applyObj.payType==6" class="actionWrap">
          <span> 合计: <i class="price" style="margin-right:2px">{{ totalPrice }}</i>{{ applyObj.symbolNameCh }}</span>
          <span class="sureBtn" @click="deliveryByHold">确认支付</span>
        </div>
        <div v-else class="actionWrap">
          <span> 合计:￥<i class="price">{{ totalPrice }}</i></span>
          <span class="sureBtn" @click="deliveryByHold">确认支付</span>
        </div>
      </div>
    </div>
    <el-dialog
      class="successDialog"
      title=""
      :visible.sync="sucessShow"
      :close-on-click-modal="false"
      width="480px"
    >
      <div class="contentInfos">
        <div class="title">支付成功</div>
        <div class="actionWrap">
          <span class="savebtn" @click="goDesc">确定</span>
        </div>
      </div>
    </el-dialog>
    <payDialog ref="payPop" @surePay="surePay" />
  </div>
</template>
<script>
/* global protocol http  util */
import HeadBack from '@/components/base/header/HeadBack.vue'
import addressList from '@/components/address/addressList.vue'
import payDialog from '@/components/base/payDialog/payDialog.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    HeadBack,
    addressList,
    payDialog
  },
  data() {
    return {
      resultPrice: 0,
      myAccount: {
        balance: null
      },
      imgUrl: '',
      sucessShow: false,
      applyObj: {},
      addressObj: {
        recipients: null,
        recipientsCellphone: null,
        city: null,
        address: null
      },
      goodImg: {},
      buyNum: 1,
      isRepeat: false,
      isPwdPay: true, // window.g.isPwdPay
      chooseAddId: null
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter', 'marketDetails']),
    totalPrice() {
      if (this.buyNum) {
        return util.floatMul(this.buyNum, this.applyObj.price)
      }
      return 0
    },
    isCanClick() { // 是否可以点击
      if (Number(this.applyObj.reserve) < Number(this.buyNum) || Number(this.myAccount.balance) < Number(this.totalPrice)) {
        return false
      }
      return true
    }
  },
  mounted() {
    this.applyObj = JSON.parse(sessionStorage.getItem('sureObj'))
    this.chooseAddId = this.applyObj.addressId
    this.addressObj.addressId = this.applyObj.addressId
    this.buyNum = this.applyObj.buyNum
    this.goodImg = this.applyObj.imgs.find(el => {
      return el.isMain === '1'
    })
    sessionStorage.setItem('mobile_market_w', 3)
    this.getAsset()
    // if (this.applyObj.payType == 6) {
    //   hqProtocol.param_subscribe.contractIds = [this.applyObj.pays[0].integralCommodityId]
    //   hqWs.send(hqProtocol.param_subscribe)
    // }
  },
  beforeDestroy() {
    // eslint-disable-next-line eqeqeq
    // if (this.applyObj.payType == 6) {
    //   hqProtocol.param_unsubscribe.contractIds = [this.applyObj.pays[0].integralCommodityId]
    //   hqWs.send(hqProtocol.param_unsubscribe)
    // }
  },
  methods: {
    changeAddId(id) {
      this.addressObj.addressId = id
    },
    getAsset() {
      if (this.applyObj.pays[0].payType === 5) {
        http.postFrontMall(protocol.param_findMyAssetMarket).then((response) => {
          const { code, message, value } = response.data
          if (code === 0 || code === '0') {
            if (value) {
              this.myAccount.balance = value?.availableFunds
            }
          } else {
            this.$toast(message)
          }
        })
      } else {
        protocol.param_findMyRewardMarket.param.rewardId = this.applyObj.pays[0].symbolId
        http.getRes(protocol.param_findMyRewardMarket).then((response) => {
          const { code, message, value } = response.data
          if (code === 0 || code === '0') {
            if (value) {
              this.myAccount.balance = value?.balance
            }
          } else {
            this.$toast(message)
          }
        })
      }
    },
    goDesc() {
      setTimeout(() => {
        this.$router.push({
          name: 'reportSystem',
          params: {
            id: 2
          }
        })
      }, 1000)
    },
    surePay(val) {
      this.payOrder(val)
    },
    payOrder(pwd) {
      const params = {
        addressId: this.addressObj.addressId,
        commodityId: this.applyObj.commodityId,
        commodityPayType: this.applyObj.payType,
        quantity: this.buyNum,
        password: this.isPwdPay ? util.getmd5('47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + pwd) : null,
        bankId: this.isPwdPay ? window.g.BANK_ID : null
      }
      protocol.param_makeOrderIntegral.param = params
      if (!this.isRepeat) {
        this.isRepeat = true
      } else {
        return
      }
      http.postFrontMall(protocol.param_makeOrderIntegral).then((response) => {
        const { code, message, value } = response.data
        this.isRepeat = false
        if (Number(code) === 0) {
          setTimeout(() => {
            this.getAsset()
          }, 1000)
          this.resultPrice = value.totalPrice
          this.sucessShow = true
        } else {
          this.$refs.payPop.closeSheet()
          this.$message(message)
        }
      }).catch(() => {
        this.isRepeat = false
      })
    },
    deliveryByHold() {
      if (Number(this.applyObj.reserve) < Number(this.buyNum)) {
        return this.$message('剩余库存不足！')
      }
      // eslint-disable-next-line eqeqeq

      if (Number(this.myAccount.balance) < Number(this.totalPrice)) {
        if (this.applyObj.payType == 6) {
          return this.$message('可用' + this.applyObj.symbolNameCh + '不足！')
        }
        return this.$message('可用资金不足！')
      }

      if (this.isPwdPay) {
        // 为真则出资金密码弹框
        // eslint-disable-next-line eqeqeq
        const typeName = this.applyObj.payType == 6 ? ('支付' + this.applyObj.symbolNameCh) : '支付余额'
        const totalPrice = this.applyObj.payType == 5 ? ('￥' + this.totalPrice) : (this.totalPrice + ' ' + this.applyObj.symbolNameCh)
        this.$refs.payPop.showSheet(totalPrice, typeName)
      } else {
        this.payOrder()
      }
    },
    isEmpty(param) {
      if (param === null || param === undefined || param === '') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
  <style lang="scss" scoped>
  .successDialog{
    /deep/.el-dialog{
        background: #424556!important;
        border-radius: 8px 8px 8px 8px;
      }
      /deep/.el-dialog__header{
         display: none;
      }
      /deep/.el-dialog__body{
        padding:40px;
      }
      .title{
        font-size: 24px;
        font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
        font-weight: bold;
        color: #FFFFFF;
        text-align: center;
      }
      .sucessTip{
        margin-top:20px;
        font-size: 20px;
        font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 30px;
        text-align: center;
      }
      .actionWrap{
        width: 95px;
        margin:40px auto 0;
      }
      .savebtn{
        width:100%;
        display: inline-block;
        height: 40px;
        background: #E4CA91;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        font-family: PingFang HK-Medium, PingFang HK;
        font-weight: 500;
        color: #5E4207;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
      }
  }
  i{
    font-style: normal;
  }
  .orderDetail{
    width: 1200px;
    background: #343646;
    border-radius: 4px 4px 4px 4px;
    margin: 30px auto;
    .orderTitle{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 70px;
      background: #424556;
      padding:0 40px;
      box-sizing: border-box;
      .leftTitle{
        font-size: 22px;
        font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
        font-weight: 500;
        color: #FFFFFF;
      }
      .accountWrap{
        font-size: 18px;
        font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
        font-weight: 500;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        .price{
          display: inline-block;
          margin:0 4px;
          font-size: 24px;
          font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
          font-weight: normal;
          color: #FFFFFF;
        }
      }
    }
    .goodInfo{
      padding:0 40px;
      .fristRow{
        font-size: 18px;
        font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
        font-weight: 400;
        color: #CCCCCC;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:20px 0;
        border-bottom:1px solid #4E5162;
        p{
          color: #CCCCCC;
        }
        .twoCol{
          width:500px;

        }
        .threeCol{
          width:200px;
          text-align: center;
        }
        .fourCol{
          width:200px;
          text-align: center;
        }
        .fiveCol{
          width:160px;
          text-align: right;
        }
      }
      .twoRow{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:20px 0;
        .twoCol{
          width:500px;
          display: flex;
          .imgWrap{
            margin-right: 10px;
            width: 83px;
            height: 83px;
            border-radius: 4px 4px 4px 4px;
          }
          .name{
            font-size: 18px;
            font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 21px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .place{
            margin-top:10px;
            font-size: 14px;
            font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 16px;
          }
          .prices{
            margin-top:10px;
            font-size: 14px;
            font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 16px;
          }
        }
        .threeCol{
          width:200px;
          text-align: center;
          font-size: 20px;
          font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
          font-weight: normal;
          color: #FFFFFF;
          line-height: 23px;
          p span{
            color: #FFFFFF;
          }
          i{
            color: #FFFFFF;
            font-style: normal;
          }
          .newSty{
            display: inline-block;
            margin-left:5px;
            height: 14px;
            padding:0 2px;
            border-radius: 2px 2px 2px 2px;
            border: 1px solid #E4CA91;
            font-size: 10px;
            font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
            font-weight: bold;
            color: #E4CA91;
            line-height: 14px;
          }
        }
        .fourCol{
          width:200px;
          text-align: center;
          /deep/.el-input-number{
            height: 30px;
            line-height: 30px;
            width: 140px;
            .el-input-number__decrease,.el-input-number__increase{
              height: 30px;
              background: #424556;
              border-radius: 4px 0px 0px 4px;
              border-color:#343646;
              color: #FFFFFF;
            }
            [class*=" el-icon-"], [class^=el-icon-]{
              color: #FFFFFF;
            }
            .el-input-number__increase{
              border-radius: 0px 4px 4px 0px;
            }
            .el-input-number__decrease.is-disabled .el-icon-minus, .el-input-number__increase.is-disabled .el-icon-minus{
               color:#9d9ea2;
             }
            .el-input__inner{
              padding-left: 30px;
              padding-right: 30px;
              height: 31px;
              line-height: 31px;
              border:none;
              background: #424556;
              font-size: 20px;
              font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
              font-weight: normal;
              color: #FFFFFF;
            }
          }
        }
        .fiveCol{
          width:160px;
          text-align: right;
          font-size: 20px;
          font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
          font-weight: normal;
          color: #FFFFFF;
          line-height: 23px;
          p span{
            color: #FFFFFF;
          }
          i{
            color: #FFFFFF;
            font-style: normal;
          }
        }
      }
    }
    .orderAction{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 70px;
      background: #424556;
      padding:0 40px;
      box-sizing: border-box;
      .leftTitle{
        font-size: 16px;
        font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
        font-weight: 400;
        color: #CCCCCC;
        display: flex;

        p{
          color:#CCCCCC;
          margin-right: 20px;
        }
          span{
            font-size: 14px;
            font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
            font-weight: 500;
            color: #808080;
          }
          .prs{
            font-size: 16px;
            font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
            font-weight: 400;
          color:#E4CA91;
        }
      }
      .actionWrap{
        font-size: 18px;
        font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
        font-weight: 500;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        span{
          color:#fff;
        }
        .price{
          font-size: 24px;
          font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
          font-weight: normal;
          color: #FFFFFF;
        }
        .sureBtn{
          display: inline-block;
          margin-left:10px;
          width: 120px;
          height: 40px;
          background: #E4CA91;
          border-radius: 4px 4px 4px 4px;
          font-size: 18px;
          font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
          font-weight: 500;
          color: #5E4207;
          line-height: 40px;
          text-align: center;
          cursor: pointer;
        }
      }
    }
    .noLeftw{
      justify-content: flex-end;
    }
  }
  </style>

